import Accordion from 'components/accordion/Accordion';
import ContentContainer from 'components/content-container/ContentContainer';
import Icon from 'components/icon/Icon';
import Link from 'components/link/Link';
import Message from 'components/message/Message';

import { IBreadcrumbs, IconWarning_Theme } from 'source/NFR.types';

const Breadcrumbs: React.FC<IBreadcrumbs> = ({ accordion, currentPage, items = [], translationLabel, root }) => {
  return (
    <Accordion showButtonText={true} {...accordion}>
      {({ Button, Collapse }) => (
        <nav className="breadcrumbs" data-epi-type="content">
          <ContentContainer className="breadcrumbs--header">
            <Button className={`breadcrumbs--toggle ${translationLabel ? 'adjust-width' : ''}`}>
              <Icon name="arrow-down" />
            </Button>
          </ContentContainer>

          <Collapse className="breadcrumbs--collapse">
            <ContentContainer element="ul" theme="wide">
              <li>
                <a className="breadcrumbs--root" href={root.url}>
                  <span>{root.text}</span>
                </a>
              </li>

              {items?.map(item => (
                <li key={item.url || item.text}>
                  <Link {...item} theme="black" />
                </li>
              ))}

              {currentPage && (
                <li className="current-page" key={currentPage}>
                  {currentPage}
                </li>
              )}

              {translationLabel && (
                <li className="breadcrumbs--right-most" key={translationLabel}>
                  <Message
                    text={{ text: translationLabel, onPageEditing: { text: translationLabel } }}
                    theme={IconWarning_Theme.None}
                    isTranslationLabel
                  />
                </li>
              )}
            </ContentContainer>
          </Collapse>
        </nav>
      )}
    </Accordion>
  );
};

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
